import { ApiConfig } from './types';

const config: ApiConfig = {
    baseUrl: 'https://api.bizzabo.com',
    authCookieAccess: 'x-bz-access-attendee-token',
    eventsUrl: 'https://events.bizzabo.com',
    previewCookieName: 'x-bz-preview',
    cloudinaryCloudName: 'bizzaboprod',
    cloudinaryUploadPreset: 'getgadzy',
    snowplowDevelopmentEndpoint: 'com-bizzabo-prod1.mini.snplow.net',
    snowplowProductionEndpoint: 'sp.bizzabo.com',
    snowplowSourceEndpoint: 'https://cdnjs.cloudflare.com/ajax/libs/snowplow/2.16.3/sp.js',
    seismoHost: 'seismo.bizzabo.com',
    realtimeNotificationsHost: 'realtimenotifications.bizzabo.com',
    dashboardUrl: 'https://accounts.bizzabo.com',
    refreshTokenUrl: '/token/refresh',
    livestreamUrl: `https://livestream.bizzabo.com`,
    muxEnvKey: 'pgi32g4avga7e59f1i960chpa',
};

export default config;
